"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "OccurrenceCalendar", {
  enumerable: true,
  get: function get() {
    return _OccurrenceCalendar.default;
  }
});
var _OccurrenceCalendar = _interopRequireDefault(require("./OccurrenceCalendar"));
function cov_2ov1y7kfxq() {
  var path = "/codebuild/output/src2586451875/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/OccurrenceCalendar/lib/index.js";
  var hash = "38b6f76a001650dae8341c52dc5cfa2b3bc297e1";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2586451875/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/OccurrenceCalendar/lib/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "38b6f76a001650dae8341c52dc5cfa2b3bc297e1"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ov1y7kfxq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ov1y7kfxq();